<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="false"
    width="400px"
    title="新增开票"
    class="invoice-dialog"
  >
    <div class="invoice-box">
      <div class="invoice-row">
        <span class="invoice-label">开票批次：</span>
        <el-select v-model="invoice['开票批次']" size="mini">
          <el-option v-for="v in batches" :key="v" :label="v" :value="v"></el-option>
        </el-select>
      </div>
      <div class="invoice-row">
        <span class="invoice-label">开票比例：</span>
        <div>
          <template v-if="invoice.开票批次 === '一次付款'">
            <span>100%</span>
          </template>
          <template v-else>
            <div class="invoice-row">
              <span class="invoice-label" style="width:50px">第一期</span
              ><el-input v-model="invoice.第一期" size="mini"></el-input><span>%</span>
            </div>
            <div class="invoice-row">
              <span class="invoice-label" style="width:50px">第二期</span
              ><el-input v-model="invoice.第二期" size="mini"></el-input><span>%</span>
            </div>
          </template>
        </div>
      </div>
      <div class="invoice-row">
        <span class="invoice-label">总金额（元）：</span>
        <el-input v-model="invoice.总金额" size="mini"></el-input>
      </div>
      <div class="invoice-row">
        <span class="invoice-label">客户公司：</span>
        <el-input v-model="invoice.客户公司" size="mini"></el-input>
      </div>
      <div class="invoice-row">
        <span class="invoice-label">开票主体：</span>
        <el-select v-model="invoice['开票主体']" size="mini">
          <el-option v-for="v in alpha" :key="v" :label="v" :value="v"></el-option>
        </el-select>
      </div>
      <div v-if="company._id" class="invoice-row">
        <span class="invoice-label">开票信息：</span>
        <div>
          <p
            v-for="file in files"
            :key="file._id"
            class="md5"
            style="cursor:pointer;color:#409EFF"
            @click="preview(file)"
          >
            {{ file.originalname }}
          </p>
          <p style="cursor:pointer;color:#409EFF" @click="upload"><i class="el-icon-upload"></i>上传附件</p>
        </div>
      </div>
    </div>
    <div class="rpg-dialog-item rpg-text-center">
      <el-button size="mini" type="primary" @click="handleConfirm">确定</el-button>
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
    </div>
    <!-- <div class="rpg-dialog-item rpg-text-center">
      <span class="rpg-tip-red">发起offer会通知相应的顾问，最终双方确认</span>
    </div> -->
    <UploadDialog ref="upload" :on-success="uploadSuccess" type="开票信息" label="开票信息" />
  </el-dialog>
</template>
<script>
const Big = require('big.js')

export default {
  data() {
    return {
      dialogVisible: false,
      finance: {},
      invoice: {},
      company: {},
      files: [],
      batches: ['一次付款', '二次付款'],
      alpha: ['北京阿尔法', '浙江阿尔法', '新疆阿尔法'],
    }
  },
  methods: {
    addInvoice() {
      this.$refs.AddInvoice.open()
    },
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    upload() {
      this.$refs.upload.visible(true)
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      try {
        const option = {
          createdAt: res.createdAt,
          fileId: res._id,
          md5: res.md5,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          type: '开票信息',
          companyId: this.company._id,
        }
        const insertRes = await app.service('company').insertCompanyAtta(option)
        if (insertRes.status !== 'success' && insertRes.status !== 200) this.$message.error(insertRes.msg)
        this.getCompanyFiles(this.company._id)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async getCompanyFiles(companyId) {
      const result = await app.service('company').getCompanyAtta(companyId)
      if (result.status === 'success') {
        this.company.附件 = result.data
        this.files = this.company.附件.filter(v => v.type === '开票信息')
      } else this.$message(result.msg)
    },
    // TODO:开票信息的公司按照项目的客户公司来查询，还是此处填写的公司
    async getCompany() {
      const res = await app.service('company').getCompany(this.finance.客户公司)
      if (res.status === 200) {
        this.company = res.result
        this.files = this.company.附件.filter(v => v.type === '开票信息')
        // TODO:如果按照项目的客户公司来，是否同时把公司全称填进去
        this.$set(this.invoice, '客户公司', this.company.公司名称)
      } else {
        this.company = {}
        this.files = []
      }
    },
    async open(finance) {
      this.finance = finance
      const total = finance.佣金额 && new Big(finance.佣金额).times(10000) || 0
      this.invoice = { 开票批次: '一次付款', 总金额: parseFloat(total) }
      this.company = {}
      this.files = []
      this.dialogVisible = true
      this.getCompany()
    },
    async handleConfirm() {
      const { invoice } = this
      if (!/^[0-9.]*$/.test(invoice.总金额)) {
        return this.$message.error('总金额请填写纯数字')
      }
      if (invoice.开票批次 === '二次付款') {
        if (!invoice.第一期 || !invoice.第二期) {
          return this.$message.error('请完善开票比例')
        }
        if (!/^[0-9.]*$/.test(this.invoice.第一期)) {
          return this.$message.error('第一期开票比例请填写纯数字')
        }
        if (!/^[0-9.]*$/.test(this.invoice.第二期)) {
          return this.$message.error('第二期开票比例请填写纯数字')
        }
        if (parseFloat(new Big(invoice.第一期).plus(invoice.第二期)) !== 100) {
          return this.$message.error('两批次之和不为100，请重新确认')
        }
      }
      this.$emit('addInvoice', this.invoice)
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped>
.invoice-row {
  display: flex;
  margin-bottom: 5px;
  align-items: center;
}
.invoice-label {
  flex: none;
  word-break: keep-all;
  width: 80px;
}
</style>
